import { render, staticRenderFns } from "./number-box.vue?vue&type=template&id=41d0fa16&scoped=true&"
import script from "./number-box.vue?vue&type=script&lang=js&"
export * from "./number-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d0fa16",
  null
  
)

export default component.exports